/**
 * 명령형 토스트 — `sonner` 단일 인스턴스 래퍼.
 *
 * heritage-ui 는 `<Toaster/>` 호스트만 export 하고 명령형 `toast()` 는 노출하지 않아
 * `sonner` 를 직접 의존한다. apps/web 과 heritage-ui 가 동일 sonner 인스턴스로 dedupe 되어
 * (`apps/web/package.json` 의 `sonner@^2.0.7` = heritage-ui 가 쓰는 범위) 이 호출이
 * app provider 에 1회 마운트된 `<Toaster/>` 에 도달한다.
 *
 * 위치·아이콘·테마는 마운트한 `<Toaster/>` 가 소유한다 — 호출부는 레벨(성공/실패/안내/경고)만
 * 고른다. 메시지는 호출부가 `UI_TEXT` 에서 가져와 넘긴다(이 래퍼는 도메인 무지).
 *
 * 용도 경계: mutation·CRUD 결과 피드백 표준. read 에러는 `ErrorState`(refetch),
 * 폼 검증 에러는 RHF/`FieldError` — toast 가 아니다.
 */
import { toast as sonnerToast } from 'sonner';

type ToastMessage = Parameters<typeof sonnerToast.success>[0];
type ToastOptions = Parameters<typeof sonnerToast.success>[1];

export const toast = {
  success: (message: ToastMessage, options?: ToastOptions) => sonnerToast.success(message, options),
  error: (message: ToastMessage, options?: ToastOptions) => sonnerToast.error(message, options),
  info: (message: ToastMessage, options?: ToastOptions) => sonnerToast.info(message, options),
  warning: (message: ToastMessage, options?: ToastOptions) => sonnerToast.warning(message, options),
};
